import { AUTH_STATE } from '../constants';

function readFromLocalStorage() {
  if (typeof window === 'undefined') return null;

  const authLocalStorage = localStorage.getItem(AUTH_STATE) || null;

  return JSON.parse(authLocalStorage);
}

export default readFromLocalStorage;
